module.exports = __webpack_public_path__ + "components/resort-finder/static/snow-finder-eccd08d4589136feded932b77c37d947.svg";